// extracted by mini-css-extract-plugin
module.exports = {"buttons":"EditTemplateModal_buttons__1hVKA","submitButton":"EditTemplateModal_submitButton__BDn7-"};